export const FIREBASE_MESSAGING_CHANNEL = 'firebase_messaging_channel';
export const FIREBASE_MESSAGING_TYPE = 'firebase_messaging_type';

export interface NotificationType {
  title: string;
  description: string;
  seen: boolean;
}
